import * as d3 from 'd3'
import {getGoogleColorByString} from '@/utils/d3Utils'
import moment from 'moment'

export default function LineChart(d, options) {
  const cfg = {
    xAxis: "x"
  };

  copyOptions(options);

  function copyOptions(options) {
    if ('undefined' !== typeof options)
      for (let i in options) if (options.hasOwnProperty(i) && 'undefined' !== typeof options[i])
        cfg[i] = options[i];
  }

  const labelXOffset = 20;

  const data = JSON.parse(JSON.stringify(d));

  const container = d3.select(options.container);

  container.selectAll("*").remove();

  const width = cfg.width - cfg.margin.left - cfg.margin.right;
  let height = cfg.height - cfg.margin.top - cfg.margin.bottom;

  if (data.length < 2) {
    container.append('div')
      .style("display", "table-cell")
      .style("width", width + 'px')
      .style("height", height + 'px')
      .style("text-align", 'center')
      .style("vertical-align", 'middle')
      .style("font-size", '14pt')
      .text("Нет данных");
    return;
  }

  let xAxisType = "date";
  let yAxisType = "number";

  if (cfg.axisData) {
    if (cfg.axisData['x']) xAxisType = cfg.axisData['x'].type || xAxisType;
    if (cfg.axisData['y']) yAxisType = cfg.axisData['y'].type || yAxisType;
  }

  const x = (xAxisType === "date" ? d3.scaleTime() : d3.scaleLinear()).range([0, width]);

  const y = (yAxisType === "date" ? d3.scaleTime() : d3.scaleLinear()).range([height - labelXOffset, 0]);

  const color = getGoogleColorByString;

  function getAxisTickFormat(axisData, axisName) {
    if (axisData && axisData[axisName]) {
      const tickFormat = axisData[axisName].tickFormat;

      const durationFormat = axisData[axisName].durationFormat;

      switch (axisData[axisName].type) {
        case "date":
          const dateFormat = tickFormat || "DD/MM";

          const startTime = d[0].x;

          return d => {
            return moment(d).format(dateFormat) + (durationFormat ? ' ' + moment.duration(new Date(d).getTime() - startTime).format(durationFormat, {trim: "both"}) : '');
          };
        case"number":
          if (tickFormat)
            return d3.format(tickFormat)
      }
    }
    return d => d;
  }

  const xAxis = d3.axisBottom().scale(x)
    .tickFormat(getAxisTickFormat(cfg.axisData, 'x'));

  if (xAxisType === "date") setAxisTicks(xAxis, cfg.axisData, 'x')

  function setAxisTicks(axis, axisData, axisName) {
    const tickFormat = axisData[axisName].tickStep;

    if (!tickFormat) return;

    let interval = null;

    switch (tickFormat.util) {
      case "S":
        interval = d3.timeMillisecond;
        break;
      case "s":
        interval = d3.timeSecond;
        break;
      case "m":
        interval = d3.timeMinute;
        break;

      case "h":
        interval = d3.timeHour;
        break;

      case "d":
        interval = d3.timeDay;
        break;

    }
    axis.ticks(interval, tickFormat.value)
  }

  const yAxis = d3.axisLeft().scale(y)
    .tickFormat(getAxisTickFormat(cfg.axisData, 'y'));

  if (yAxisType === "date") setAxisTicks(yAxis, cfg.axisData, 'y')

  const svg = container.append("svg")
    .attr("width", cfg.width)
    .attr("height", cfg.height);

  const g = svg.append("g")
    .attr("transform",
      "translate(" + cfg.margin.left + "," + cfg.margin.top + ")");

  x.domain(d3.extent(data, d => xAxisType === "date" ? new Date(d[cfg.xAxis]) : d[cfg.xAxis]));

  const maxY = d3.max(data, d => d3.max(d3.keys(d).map(key => key !== cfg.xAxis ? d[key] || Number.MIN_VALUE : Number.MIN_VALUE)));
  const minY = d3.min(data, d => d3.min(d3.keys(d).map(key => key !== cfg.xAxis ? d[key] || Number.MAX_VALUE : Number.MAX_VALUE)));

  const delta = maxY - minY;

  if (yAxisType === "number")
    y.domain(cfg.reverse ? [maxY + delta * 0.2, minY - delta * 0.2] : [minY - delta * 0.2, maxY + delta * 0.2]);
  else
    y.domain(cfg.reverse ? [new Date(maxY + delta * 0.2), new Date(minY - delta * 0.2)] : [new Date(minY - delta * 0.2), new Date(maxY + delta * 0.2)]);

  for (let p in data[0]) {
    if (!data[0].hasOwnProperty(p) || p === cfg.xAxis) continue;

    const xy = data.map(v => ({x: v[cfg.xAxis], y: v[p]})).filter(v => v.y !== null);

    g.append("path")
      .data([xy])
      .attr("class", "line")
      .attr("d", d3.line()
        .x(d => x(xAxisType === "date" ? new Date(d.x) : d.x))
        .y(d => y(yAxisType === "date" ? new Date(d.y) : d.y)))
      .attr('fill', 'none')
      .attr('stroke', color(p))
      .attr('stroke-width', '1.5px');
  }

  const xAxisLine = g.append('g')
    .attr('class', 'x axis')
    .attr('transform', 'translate(0,' + (height - labelXOffset) + ')')
    .call(xAxis);


  if (cfg.axisData.x.tickLabelRotation) {
    xAxisLine
      .selectAll("text")
      .style("text-anchor", "start")
      .attr("dx", "1em")
      .attr("dy", "-.2em")
      .attr("transform", d => "rotate(" + cfg.axisData.x.tickLabelRotation + ")");
  }

  g.append('g')
    .attr('class', 'y axis')
    .call(yAxis);

  g.append("text")
    .attr("text-anchor", "middle")
    .attr("transform", "translate(" + (-cfg.margin.left + 20) + "," + (height / 2) + ")rotate(-90)")
    .text(cfg.axisLabels.y);

  g.append("text")
    .attr("text-anchor", "middle")
    .attr("transform", "translate(" + width / 2 + "," + (height + cfg.margin.top + cfg.margin.bottom - 30) + ")")
    .text(cfg.axisLabels.x);
}
